import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"flag\">\n  <polygon points=\"14.4 6 14 4 5 4 5 21 7 21 7 14 12.6 14 13 16 20 16 20 6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol